import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Autocomplete } from "@material-ui/lab";
import { getCursoById, updateCurso } from "../../../../api/curso";
import { getUsers } from "../../../../api/user";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyDocente() {
  return {
    docente: "",
    obs: "",
    nRegistro: "",
    active: true,
    esDirector: false,
  };
}

export default function EditDocentePage() {
  const [docente, setDocente] = useState(getEmptyDocente());
  const [curso, setCurso] = useState({});
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const docenteId = useParams().id;
  const cursoId = useParams().cursoId;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resUsers = await getUsers();
        if (resUsers.status === 200) {
          setUsers(
            resUsers.data.filter(
              (x) => x.role === "docente" || x.esDocente === true
            )
          );
        }

        getCursoById(cursoId)
          .then((res) => {
            if (res.status === 200) {
              setCurso(res.data);
              if (docenteId) {
                setDocente(
                  res.data.docentes?.find((x) => x._id === docenteId)
                );
                setSelectedUser(
                  resUsers.data.find(
                    (x) =>
                      x._id ===
                      res.data.docentes?.find((x) => x._id === docenteId)?.docente
                  )
                );
              }

              disableLoadingData();
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get docente.",
            });
            history.push("/cursos");
          });
      } catch (error) {}
    };
    fetchData();
  }, [cursoId, docenteId, disableLoadingData, history]);

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={obj.active}
                      onChange={() => setObj({ ...obj, active: !obj.active })}
                      name="checkActive"
                    />
                  }
                  label="Active"
                />

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  function saveDocente() {
    let saveCurso = curso;
    let saveDocente = docente;
    saveDocente.docente = selectedUser._id;
    if (docenteId) {
      saveCurso = {
        ...saveCurso,
        docentes: saveCurso.docentes.map((item) =>
          item._id === docenteId ? saveDocente : item
        ),
      };
    } else {
      if (!Array.isArray(saveCurso.docentes)) {
        saveCurso.docentes = [];
      }
      saveCurso.docentes.push(saveDocente);
    }
    updateCurso(cursoId, saveCurso)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/edit-curso/" + cursoId);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const handleChange = (element) => (event) => {
    setDocente({ ...docente, [element]: event.target.value });
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/edit-curso/" + cursoId),
            onSave: saveDocente,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!docenteId,
            setObj: setDocente,
            obj: docente,
          })}
          <CardHeader title="Editar Precio"></CardHeader>
          <CardBody>
            <div className="d-flex">
              <div className="col-md-6">
                <Autocomplete
                  className="w-100 mr-5"
                  id="autocomplete-familia"
                  filterSelectedOptions
                  options={users}
                  getOptionLabel={(option) =>
                    (option?.fullName || "") + " " + (option?.dni || "")
                  }
                  value={selectedUser || ""}
                  onChange={(event, selected) => {
                    setSelectedUser(selected);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Seleccionar docente"
                    />
                  )}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  id="nRegistro"
                  label="Número de registro"
                  value={docente.nRegistro || ""}
                  onChange={handleChange("nRegistro")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </div>
            </div>
            <div className="d-flex">
              <div className="col-md-12">
                <TextField
                  id="obs"
                  label="Observaciones"
                  value={docente.obs || ""}
                  onChange={handleChange("obs")}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="normal"
                  multiline
                  variant="outlined"
                  fullWidth
                />
              </div>
            </div>

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={docente.active || false}
                    onChange={() =>
                      setDocente({ ...docente, active: !docente.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!docente.esDirector}
                    onChange={() =>
                      setDocente({ ...docente, esDirector: !docente.esDirector })
                    }
                    name="checkDirector"
                  />
                }
                label="Director del curso (doble certificado; puede haber más de uno)"
              />
            </div>
          </CardBody>
        </Card>
        {docenteId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this docente?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                let saveCurso = {
                  ...curso,
                  docentes: curso?.docentes?.filter((x) => x._id !== docenteId),
                };
                updateCurso(cursoId, saveCurso)
                  .then((res) => {
                    if (res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Docente deleted",
                      });
                      history.push("/edit-curso/" + cursoId);
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not save changes.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
